import { Buffer } from 'buffer';

export const validateToken = () => {
  const loginType = localStorage.getItem('loginType');

  // 👇 LOGIN CLIENTE
  if (loginType === 'cliente') {
    const token = localStorage.getItem('token');

    return Boolean(token);
  }

  // 👇 LOGIN INTERNO (AZURE)
  const token = localStorage.getItem('token');
  const expires = localStorage.getItem('expiresToken');
  const azureId = localStorage.getItem('azureId');

  return Boolean(
    token &&
    expires &&
    azureId &&
    new Date(expires) > new Date()
  );
};

export const parseParamToObject = (search: string) => {
  if (search) {
    const params = search.substring(1).split('&');
    const obj: Record<string, string> = {};

    for (const param of params) {
      const [key, value] = param.split('=');
      obj[key] = decodeURIComponent(value);
    }

    return obj;
  }
  return {};
};

export const parseJwt = (tokenParam?: string) => {
  try {
    const token = tokenParam || localStorage.getItem('token');

    if (!token || token.split('.').length !== 3) {
      return null;
    }

    return JSON.parse(
      Buffer.from(token.split('.')[1], 'base64').toString()
    );
  } catch (error) {
    return null;
  }
};